export default __webpack_public_path__ + "static/media/facilityMgmt_BG.bdbd8027.jpg";